<template>
  <v-content class="blue-grey darken-3" style="padding:0!important;">
    <v-layout align-center fill-height wrap row :style="`height:${frameHeight}px;`">
      <v-flex xs12 md6 class="primary hidden-sm-and-down">
        <v-img
          cover
          :style="`height:${frameHeight}px;`"
        >
        </v-img>
      </v-flex>
      <v-flex xs12 md6 class="fill-height align-center elevation-15" :style="`height:${frameHeight}px;`">
        <v-card class="elevation-24 align-center pa-2" :style="`height:${frameHeight-3}px;`">
          <v-card class="text-xs-center pt-5 elevation-0 align-center title text-uppercase">
            <img src="" width="216" alt="">
            <span class="font-weight-light">DRMAEN</span>
            <span>UPDATES</span>
            <v-divider class="my-1 mx-1"  v-if="!forgetpass"></v-divider>
          </v-card>
          <v-card-text class="text-xs-center" v-if="false">
            <v-form>
              <v-text-field append-icon="person" name="email" label="Email" type="text" v-model="user.email"></v-text-field>
              <v-text-field v-if="!forgetpass" append-icon="lock" name="password" label="Password" id="password" type="password" v-model="user.password"></v-text-field>
            </v-form>
            <span v-if="!forgetpass" class="error--text">{{ error }}</span>
            <span v-if="forgetpass" class="error--text">{{ resetStat }}</span>
          </v-card-text>
          <v-card-actions v-if="false">
            <v-spacer></v-spacer>
            <span v-if="!forgetpass" @click="forgetpass  = true" style="cursor:pointer" class="mx-2 blue--text">Forget password?</span>
            <span v-if="forgetpass" @click="forgetpass  = false" style="cursor:pointer" class="mx-2 blue--text">Sign in</span>
            <v-btn v-if="!forgetpass" color="primary" @click="login" :loading="loading">Login</v-btn>
            <v-btn v-if="forgetpass" color="primary" @click="resetPass" :loading="loading">Send Reset Email</v-btn>
          </v-card-actions>
          <v-divider class="my-1 mx-1"  v-if="!forgetpass"></v-divider>
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center">
              <span style="font-size:11px;font-weight:600;">LOGIN VIA</span>
            </v-flex>
            <v-flex xs12 md12 class="text-xs-center">
              <v-btn outline x-large color="#db4437" @click="OauthLogin(0)" dark>Google</v-btn>
              <v-btn outline x-large color="#3b5998" @click="OauthLogin(1)" dark v-if="false">Facebook</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      
    </v-layout>
  </v-content>
</template>

<script>
import {firebase, db, auth} from '@/fb'

export default {
  data: () => ({
    frameHeight:0,
    loading: false,
    forgetpass:false,
    error:null,
    resetStat:null,
    user: {
      email: null,
      password: null
    }
  }),

  methods: {
    goTo(path) {
      this.$router.push(path)
    },
    resetPass(){
      console.log(this.user.email)
      auth.sendPasswordResetEmail(this.user.email).then((data) => {
        this.resetStat = `Sent successfully to ${this.user.email}`
      }).catch((error) => {
        this.resetStat = error.message
      });
    },
    login () {
      this.loading = true;
      firebase.auth().signInWithEmailAndPassword(this.user.email, this.user.password).then(
          (resp) => {
            this.goTo('/')
          },
          (err) => {
            this.error = err.message
            this.loading = false;
          }
        );
    },
    OauthLogin (p) {
      var provider
      switch (p) {
        case 0:
          provider = new firebase.auth.GoogleAuthProvider();
          break;
        case 1:
          provider = new firebase.auth.FacebookAuthProvider();
          break;
        case 2:
          provider = new firebase.auth.TwitterAuthProvider();
          break;
        default:
          break;
      }
      firebase.auth().signInWithPopup(provider).then((result) => {
        this.goTo('/')
      }).catch((error) => {
        var errorMessage = error.message;
        this.error = error.message
      });
    },
    setH(){
      let h = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
      this.frameHeight = h
    },
  },
  created(){
    
  },
  mounted(){
    this.setH()
  }

};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
